




















import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import Input from './input'
import * as ruleNames from './constants/ruleNames'

export type Option =
  | {
      label: string | number
      value: string | number
    }
  | string
  | number

@Component
export default class RadioInput2 extends mixins(Input) {
  @Prop(Array) options!: Array<Option>

  @Prop({ default: () => [] }) labelClasses!: string[]
  @Prop({ default: () => [] }) inputClasses!: string[]

  get innerOptions() {
    return this.options.map(o => {
      return typeof o === 'object' && o !== null ? o : { value: o, label: o }
    })
  }

  supportedRules: Array<string> = [ruleNames.REQUIRED]
}
